<template>
    <div>

        <vue-topprogress ref="loadingProgress"></vue-topprogress>

        <div class="animated fade-in" v-if="!loading && order">
            <h1 class="display-4 font-weight-lighter">
                <span v-if="order.number">Order #{{order.number}}</span>
                <span v-if="order.number && order.po_number"> (PO #{{ order.po_number }})</span>
                <span v-if="!order.number && order.po_number">PO #{{ order.po_number }}</span>
                <!-- <span class="float-right">{{ runningTotal }}</span> -->
            </h1>

            <div v-if="order && order.order_commits && order.order_commits.length">
              <b-alert show>
                  An edit has been requested for this order and has yet to be reviewed, please check your email to review a receipt of the changes submitted. <button class="btn btn-sm btn-link p-0" @click="view_commit=true">Click here to preview the updated BOL.</button> <b>If the edit is urgent please contact us at the number above.</b>
              </b-alert>
              <c-modal size="xl" title="Updated Bill of Lading" :show.sync="view_commit">
                <bill-of-lading :order_commit="order.order_commits[0]" :customer="order.customer"></bill-of-lading>
                <template v-slot:footer-wrapper><div></div></template>
              </c-modal>
            </div>

            <c-row class="my-4">
                <c-col md="6"><c-button :to="'/orders/'+this.order_id+'/bill-of-lading'" class="btn-sf text-uppercase" block>PRINT BILL OF LADING</c-button></c-col>
                <c-col md="6"><c-button :to="'/orders/'+this.order_id+'/load-confirmation'" class="btn-sf text-uppercase" block>PRINT LOAD CONFIRMATION</c-button></c-col>
            </c-row>
            <c-row class="my-4">
                <c-col>
                    <b-progress class="mt-2" :value="progress_value" height="30px">
                        <b-progress-bar
                                :key="index"
                                v-for="(item, index) in progress_items"
                                :value="100*(1/progress_items.length)"
                                :variant="(item.log ? item.log.order_status.getVariant : item.status.getVariant)"
                                :class="['order-progress',(index > (progress_value-1) ? 'muted' : '')]"
                        >
                            <div>{{ item.log ? item.log.order_status.name : item.status.name }}<span v-if="item.log"> ({{ item.log.created_at | moment('LL') }})</span></div>
                        </b-progress-bar>
                    </b-progress>
                </c-col>
            </c-row>
            <b-table
                    hover
                    class="my-4"
                    :items="order.order_items"
                    :fields="fields"
            >
                <template v-slot:cell(product)="data">
                    <document-preview
                            v-if="data.item.product && data.item.product.getPrimaryImage()"
                            :document="data.item.product.getPrimaryImage()"
                            class="d-inline-block float-left mr-3"
                            :width="100"
                    ></document-preview>
                    {{ data.item.getFilteredName() }}
                </template>
                <template v-slot:cell(fill)="data">
                    <i v-if="+(data.item.fill)" class="fal fa-check"></i>
                </template>
            </b-table>


            <b-tabs>
                <b-tab v-for="(drop) in filteredDrops" :title="'Drop '+drop" :disabled="(drops[drop] ? false : true)" :key="'drop-tab-'+drop">
                    <b-card no-body>
                        <b-card-body>
                            <b-row v-if="drops[drop] && drops[drop].contact">
                                <b-col cols="1" class="font-weight-bolder">CONTACT</b-col>
                                <b-col>{{ drops[drop].contact.full_name }}</b-col>
                            </b-row>
                            <b-row v-if="drops[drop] && drops[drop].location">
                                <b-col cols="1" class="font-weight-bolder">SHIPPING</b-col>
                                <b-col>{{ drops[drop].location.address }}</b-col>
                            </b-row>
                            <b-row v-if="drops[drop] && drops[drop].note">
                                <b-col cols="1" class="font-weight-bolder">NOTE</b-col>
                                <b-col>{{ drops[drop].note.full_name }}</b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-tab>
            </b-tabs>

            <upload-table v-if="order && order.documents && order.documents.length" :documents="order.documents" :show_header="false" :hidden_fields="['size', 'description', 'actions']" :disable_upload="true"></upload-table>

        </div>

    </div>
</template>

<script>
  import Product from "../../models/Product";
  import OrderStatusLog from "../../models/OrderStatusLog";
  import OrderStatus from "../../models/OrderStatus";
  import DocumentPreview from "../../components/documents/DocumentPreview";
  import OrderRetrieve from "../../helpers/OrderRetrieve";
  import UploadTable from "../../components/documents/UploadTable";
import BillOfLading from '../../components/order/print/BillOfLading';

  // import FetchPriceLists from "@/components/shared/mixins/FetchPriceLists";

  export default {
      name: 'OrderDetail',
      components: {UploadTable, DocumentPreview, BillOfLading},
      mixins: [],
      data () {
        return {
          loading: true,
          order_id: this.$route.params.order_id,
          order: null,
          status_logs: null,
          progress_items: [],
          cancelled: false,
          progress_value: null,
          fields: [
            { key: 'product', label: 'Product' },
            { key: 'quantity', label: 'Quantity' },
            { key: 'drop', label: 'Drop' },
            { key: 'fill', label: 'Fill' }
          ],
          drops: {},
          notes: [],
          view_commit: false,
        }
      },
      computed: {
        runningTotal() {
          return Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD'}).format(_.sumBy(this.order.order_items, (item) => { return this.calculatePrice(item) })) || 0;
        },
        filteredDrops() {
          return [1,2,3].filter(i=>(this.order.order_items.filter(j=>j.drop===i).length>0));
        }
      },
	  methods: {
        initStatuses: function() {
          this.status_logs = OrderStatusLog.query().where('order_id', +(this.order_id)).orderBy('updated_at').with(['order_status']).get();
          let highest = 0;
          let progress = 0;
          this.status_logs.forEach((log) => {
            if(log.order_status.position > highest) {
              highest = log.order_status.position;
            }
            this.progress_items.push({log});
            progress++;
          });
          this.progress_value = 100 * (progress / 100);
          let statuses = OrderStatus.query().orderBy('position').where('position', value => value > highest).get();
          statuses.forEach((status) => {
            this.progress_items.push({status});
          });
        },
        initDrops: function() {
          this.order.order_contacts.forEach((order_contact) => {
            if(order_contact.drop) {
              if(!this.drops[order_contact.drop]) {
                this.drops[order_contact.drop] = {};
              }
              this.drops[order_contact.drop].contact = order_contact.contact;
            }
          });

          this.order.order_locations.forEach((order_location) => {
            if(order_location.drop) {
              if(!this.drops[order_location.drop]) {
                this.drops[order_location.drop] = {};
              }
              this.drops[order_location.drop].location = order_location.location;
            }
          });

          this.order.order_notes.forEach((order_note) => {
            if(order_note.drop) {
              if(!this.drops[order_note.drop]) {
                this.drops[order_note.drop] = {};
              }
              this.drops[order_note.drop].note = order_note.note;
            } else {
              this.notes.push(order_note);
            }
          });
        },
        init: function() {
          this.$refs.loadingProgress.start();
          this.loading = true;
          let handler = new OrderRetrieve(+(this.order_id));
          return handler.fetch().then(() => {
            this.order = handler.populate();
            this.initDrops();
            this.initStatuses();
            this.$refs.loadingProgress.done();
            this.loading = false;
          });
        }
      },
      mounted() {
        this.init();
      },
      created() {
        this.loading = true;
      }
	}
</script>
<style>
.order-progress {
    font-size: 1.1em;
}
.muted {
    opacity: 0.2;
}
</style>